import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_daarv8jc3a: FaireBrandEntity = {
  token: "b_daarv8jc3a",
  type: "brand",
  name: "Phaidon",
  avatarUrl:
    "https://cdn.faire.com/fastly/e81bd99be8ec59ddca25e1d25b2235859024360978ae2371928a5ffc8b6cde81.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/e81bd99be8ec59ddca25e1d25b2235859024360978ae2371928a5ffc8b6cde81.jpeg",
  minimumOrderDollars: 150,
  rating: 4.9,
  reviewCount: 30,
  isTopShop: true,
  description:
    "Phaidon is the premier global publisher of the creative arts. We work with the world's most influential authors to produce innovative books on art, photography, design, architecture, fashion, food, and travel, and illustrated books for children.",
  meta: {
    source: "api",
    importedAt: "2026-04-07T00:00:00.000Z",
    importedBy: "entity-db-cli",
  },
};
